<script>
	import { ChevronUp } from '@steeze-ui/heroicons';
	import { ChevronDown } from '@steeze-ui/heroicons';
	import { Icon } from '@steeze-ui/svelte-icon';
	import { slide } from 'svelte/transition';
	let show = false;
	export let label = '';
	export let optional = false;
</script>

<div class="mb-4 rounded-md border border-gray-700">
	<button
		class="label-text h-full w-full p-3 text-lg"
		on:click={() => (show = !show)}
	>
		<div class="flex justify-between">
			<span>
				{label}
			</span>

			<div class="flex items-center text-callout text-info">
				{#if optional}
					<span class="text-opacity-80">(optional)</span>
				{/if}
				<Icon
					src={show ? ChevronUp : ChevronDown}
					theme="solid"
					size="1.5rem"
					class="ml-1 mt-[.15rem]"
				/>
			</div>
		</div>
	</button>
	{#if show}
		<div class="mb-3 p-2" transition:slide={{ duration: 200 }}>
			<slot name="hidden-component" />
		</div>
	{/if}
</div>
